import React, { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import mainImg from "./../assets/23Anv.webp";
import annadan from "./../assets/AnnadanSeva/Annadan.webp";
import gita from "./../assets/gita.webp";
import kirtan from "./../assets/Kirtan.webp";
import pushpaMaha from "./../assets/MahaPushpaAbhieksham.webp";
import barcode1 from "./../assets/barcode1.webp";
import barcode2 from "./../assets/barcode2.webp";
import gulabiImg from "./../assets/gulabi.webp";
import lotusImg from "./../assets/lotus.webp";
import jasmineImg from "./../assets/jasmine.webp";
import marigoldImg from "./../assets/marigold.webp";
import whiteFlowerImg from "./../assets/whiteFlower.webp";
import lilyImg from "./../assets/lily.webp";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const AnniversaryIskcon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Flower Section
  const [quantities, setQuantities] = useState({});

  const flowers = [
    {
      id: 1,
      name: "Marigold flower",
      price: 70,
      unit: "kg",
      image: marigoldImg,
    },
    {
      id: 2,
      name: "Jasmine flower",
      price: 600,
      unit: "kg",
      image: jasmineImg,
    },
    { id: 3, name: "Gulabi flower", price: 200, unit: "kg", image: gulabiImg },
    { id: 4, name: "Lily flower", price: 300, unit: "kg", image: lilyImg },
    {
      id: 5,
      name: "Chrysanthemum flower",
      price: 600,
      unit: "Kg",
      image: whiteFlowerImg,
    },
    { id: 6, name: "Lotus flower", price: 240, unit: "Dozen", image: lotusImg },
  ];

  const adjustQuantity = (id, change) => {
    setQuantities((prev) => {
      const newQuantity = (prev[id] || 0) + change;
      return { ...prev, [id]: newQuantity > 0 ? newQuantity : 0 };
    });
  };

  const [amount, setAmount] = useState("");
  const paymentOptions = [
    {
      amount: 550000,
      description: "One Day Anna Daan Seva",
      isHighlight: true,
    },
    { amount: 27500, plates: 500 },
    { amount: 11000, plates: 200 },
    { amount: 5500, plates: 100 },
    { amount: 3300, plates: 60 },
    { amount: 2200, plates: 40 },
    { amount: 1100, plates: 20 },
  ];

  const [copiedText, setCopiedText] = useState(null);

  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };

  const eventData = [
    { id: 1, title: "Pushpa Maha Abhisekham", image: pushpaMaha },
    { id: 2, title: "Maha Annadan", image: annadan },
    { id: 3, title: "Bhagavad Gita Class", image: gita },
    { id: 4, title: "Kirtan", image: kirtan },
  ];

  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleChange(e);
  };

  const [formData, setFormData] = useState({
    honoreeName: "",
    relationship: "",
    donorName: "",
    email: "",
    totalAmount: 0,
    mobileNumber: "",
    dateOfBirth: "",
    receivePrasadam: false,
    receiveCertificate: false,
    panNumber: "",
    doorNumber: "",
    houseName: "",
    streetName: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      formData.totalAmount === 0 ||
      formData.mobileNumber === "" ||
      formData.email === "" ||
      formData.honoreeName === "" ||
      (formData.receiveCertificate && formData.panNumber === "")
    ) {
      alert("Please enter all required fields");
      return;
    }

    let isFormDataStored = false;
    let description = "Annadaan Seva";

    if (quantities && Object.keys(quantities).length > 0) {
      const flowerDescriptions = flowers
        .filter((flower) => quantities[flower.id] > 0)
        .map(
          (flower) =>
            `${flower.name} (${quantities[flower.id]} ${flower.unit})`,
        );
      description = `Annadaan Seva and Flower Seva: ${flowerDescriptions.join(", ")}`;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        { amount: formData.totalAmount, currency: "INR" },
      );

      const order = response.data;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: formData.totalAmount * 100,
        currency: "INR",
        name: "ISKCON Anniversary Donation",
        description: description,
        order_id: order.id,
        notes: {
          honoreeName: formData.honoreeName,
          donorName: formData.donorName,
          donorEmail: formData.email,
          mobileNumber: formData.mobileNumber,
          SevaDate: new Date().toISOString(),
          ...(formData.receiveCertificate && { panNumber: formData.panNumber }),
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData },
              },
            );
            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              await storeFormData("Payment Successful");
              isFormDataStored = true;
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobileNumber,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const storingFormData = {
      paymentStatus,
      amount: formData.totalAmount,
      honoreeName: formData.honoreeName,
      relationship: formData.relationship,
      donorName: formData.donorName,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      dateOfBirth: formData.dateOfBirth,
      receivePrasadam: formData.receivePrasadam ? "Yes" : "No",
      receiveCertificate: formData.receiveCertificate ? "Yes" : "No",
      panNumber: formData.panNumber,
      doorNumber: formData.doorNumber,
      houseName: formData.houseName,
      streetName: formData.streetName,
      area: formData.area,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      pincode: formData.pincode,
      SevaDate: new Date().toISOString(),
    };

    const formBody = new URLSearchParams(storingFormData).toString();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxAU3Ns1uc4DBwaD0x1Q20t9Bo4LwU8J4W4LHE9JWZPuoFYIk4QVO45rEO1lA3qEqMl/exec",
        {
          method: "POST",
          body: formBody,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      );

      setFormData({
        honoreeName: "",
        relationship: "",
        donorName: "",
        email: "",
        totalAmount: 0,
        mobileNumber: "",
        dateOfBirth: "",
        receivePrasadam: false,
        receiveCertificate: false,
        panNumber: "",
        doorNumber: "",
        houseName: "",
        streetName: "",
        area: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
      });

      setQuantities({});
      setAmount("");
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Some error occurred");
    }
  };

  const getTotalAmount = () => {
    const validAmount = Number(amount) || 0;
    const validQuantities = quantities || {};
    return (
      validAmount +
      Object.keys(validQuantities).reduce((acc, id) => {
        const flower = flowers.find((f) => f.id === Number(id));
        return acc + (validQuantities[id] || 0) * (flower?.price || 0);
      }, 0)
    );
  };

  useEffect(() => {
    const totalAmount = getTotalAmount();
    setFormData((prev) => ({ ...prev, totalAmount }));
  }, [amount, quantities]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          ISKCON Vijayawada Anniversary – Celebrating Devotion & Service
        </title>
        <meta
          name="description"
          content="Celebrate the ISKCON Vijayawada temple anniversary with us—special events, kirtans, prasadam, and reflections on years of devotion and seva."
        />
        <meta
          name="keywords"
          content="ISKCON vijayawada anniversary event, ISKCON vijayawada Temple anniversary celebration, Krishna event Vijayawada, ISKCON vijayawada milestone celebration"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="ISKCON Vijayawada Anniversary – Celebrating Devotion & Service"
        />
        <meta
          property="og:description"
          content="Celebrate the ISKCON Vijayawada temple anniversary with us—special events, kirtans, prasadam, and reflections on years of devotion and seva."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/anniversary"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ISKCON Vijayawada Anniversary – Celebrating Devotion & Service"
        />
        <meta
          name="twitter:description"
          content="Celebrate the ISKCON Vijayawada temple anniversary with us—special events, kirtans, prasadam, and reflections on years of devotion and seva."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/anniversary"
        />
      </Helmet>

      <Header />

      <div className="w-full flex flex-col justify-center items-center space-y-5 md:space-y-10">
        {/* Section 1 – Hero Banner */}
        <div className="w-full">
          <img
            loading="lazy"
            src={mainImg}
            alt="ISKCON Vijayawada Anniversary"
            className="w-full"
          />
        </div>

        {/* Section 2 – Intro Text */}
        <div className="px-4 sm:px-6 lg:px-16 text-center max-w-5xl mx-auto">
          <div className="mb-4">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#C61D21] mb-2">
              ISKCON Vijayawada Anniversary – Years of Devotion
            </h1>
            <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-[#FFB700] mb-4">
              Celebrate Our Spiritual Journey with Special Events &amp; Seva
            </h2>
          </div>
          <p className="text-black text-base lg:text-xl font-semibold lg:font-bold mb-3">
            ISKCON Vijayawada Celebrates Another Glorious Anniversary!
          </p>
          <p className="text-black text-sm lg:text-lg mb-3">
            Join us in celebrating a monumental milestone — another Anniversary
            of ISKCON Sri Radha Shyam Sundar Mandir. Situated in the heart of
            Vijayawada, this sacred temple has been a beacon of spirituality,
            peace, and devotion for hundreds of visitors every day.
          </p>
          <p className="text-black text-sm lg:text-lg">
            This year's celebration promises to be a grand occasion filled with
            vibrant festivities, divine rituals, and an outpouring of love for
            Sri Radha Shyam Sundar.
          </p>
        </div>

        {/* Section 3 – Event Cards */}
        <div className="w-full px-3 sm:px-6">
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 max-w-4xl mx-auto">
            {eventData.map((event) => (
              <div
                key={event.id}
                className="w-full bg-[#C61D21] flex flex-col justify-center items-center p-3 rounded-xl lg:rounded-2xl space-y-4 border-4 border-solid border-[#FFB700]"
              >
                <img
                  loading="lazy"
                  src={event.image}
                  alt={event.title}
                  className="w-full rounded-lg"
                />
                <p className="text-white text-lg lg:text-2xl font-semibold pb-2">
                  {event.title}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Section 4 – Annadaan Seva */}
        <div className="w-full flex flex-col items-center justify-center bg-[#C61D21] p-3 sm:p-4">
          <h1 className="text-white text-3xl md:text-5xl font-semibold mb-4 p-2 text-center">
            Annadaan Seva
          </h1>

          <div className="grid grid-cols-2 gap-2 mt-2 w-full sm:w-[90%] lg:w-[80%] max-w-2xl">
            {paymentOptions.slice(1).map((option, index) => (
              <button
                key={index}
                onClick={() => setAmount(option.amount)}
                className={`bg-[#F9E7D0] text-red-800 text-center py-2 rounded-xl transition focus:outline-none ${
                  amount === option.amount
                    ? "bg-[#FAC785]"
                    : "hover:bg-[#FAC785]"
                }`}
              >
                <p className="text-black text-lg lg:text-xl font-bold">
                  ₹{option.amount.toLocaleString()}
                </p>
                <p className="text-black text-sm lg:text-base">
                  ({option.plates} Plates)
                </p>
              </button>
            ))}
          </div>

          <div className="my-5 w-full sm:w-[90%] lg:w-[80%] max-w-2xl">
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full text-lg px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 bg-white text-black"
              placeholder="₹ Donate As You Wish"
            />
          </div>
        </div>

        {/* Section 5 – Pushpa Abhishek Seva */}
        <div className="w-full lg:w-[95%] flex flex-col items-center justify-center bg-[#E2CFAF] text-center border-0 lg:border-4 border-solid border-[#C61D21]">
          <h1 className="w-full text-white bg-[#C61D21] text-2xl lg:text-4xl font-bold mb-4 p-3">
            Pushpa Abhishek Seva
          </h1>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 w-full lg:w-[98%] p-2 lg:mb-4">
            {flowers.map((flower) => (
              <div
                key={flower.id}
                className="border-4 border-solid border-[#C61D21] rounded-lg shadow-md flex flex-col items-center"
              >
                <h2 className="w-full text-white bg-[#C61D21] text-xs sm:text-sm lg:text-xl p-1 lg:p-2 font-bold mb-2">
                  {flower.name}
                </h2>
                <img
                  loading="lazy"
                  src={flower.image}
                  alt={flower.name}
                  className="object-contain rounded-lg mb-2 p-1 h-24 sm:h-32 lg:h-40"
                />
                <p className="text-red-700 text-sm lg:text-xl font-semibold mb-3">
                  Per {flower.unit}: ₹{flower.price}
                </p>
                <div className="flex items-center gap-2 mb-3">
                  <button
                    onClick={() => adjustQuantity(flower.id, -1)}
                    className="bg-white text-black px-3 py-1 text-base lg:text-xl rounded-md border border-black"
                  >
                    -
                  </button>
                  <span className="bg-white rounded-md px-3 py-1 text-base lg:text-xl font-bold border border-black min-w-[2rem] text-center">
                    {quantities[flower.id] || 0}
                  </span>
                  <button
                    onClick={() => adjustQuantity(flower.id, 1)}
                    className="bg-white text-black px-3 py-1 text-base lg:text-xl rounded-md border border-black"
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Section 6 – Donation Form */}
        <div className="w-full flex flex-col items-center justify-center px-4 pb-4">
          <form className="w-full sm:w-[90%] lg:w-[60%] border-2 border-solid border-[#C61D21] bg-[#F9E7D0] rounded-lg p-4 shadow-lg">
            <h2 className="text-2xl font-bold mb-2 text-center text-[#C61D21]">
              In Memory Of
            </h2>
            <p className="w-full text-base text-black text-center mb-4">
              I want my donation to be dedicated to:
            </p>

            <div className="mb-4">
              <input
                type="text"
                name="honoreeName"
                value={formData.honoreeName}
                onChange={handleChange}
                placeholder="Honouree Name"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>

            <div className="mb-4">
              <input
                type="text"
                name="relationship"
                value={formData.relationship}
                onChange={handleChange}
                placeholder="Relationship"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>

            <h2 className="text-xl font-bold mt-6 mb-4 text-center text-[#C61D21]">
              Personal Details
            </h2>

            <div className="mb-4">
              <input
                type="text"
                name="donorName"
                value={formData.donorName}
                onChange={handleChange}
                placeholder="Donor Name *"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email ID"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="tel"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                placeholder="Mobile Number *"
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                required
              />
            </div>

            <div className="mb-4">
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
              />
              <p className="text-sm lg:text-base text-gray-600 mt-1">
                (Sankalpa and Archana will be performed for you on your
                birthday)
              </p>
            </div>

            <div className="mb-2 flex items-center">
              <input
                type="checkbox"
                name="receiveCertificate"
                checked={formData.receiveCertificate}
                onChange={handle80GCheckboxChange}
                className="mr-2 accent-[#C61D21]"
              />
              <label className="text-sm lg:text-base">
                I would like to receive 80(G) Certificate
              </label>
            </div>

            {show80GDetails && (
              <div className="mb-3">
                <p className="text-black text-sm lg:text-base text-left mb-2">
                  Finance Act 2021 mandates uploading donation details for 80(G)
                  deductions. Ensure PAN and address details are provided.
                </p>
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber}
                  onChange={handleChange}
                  placeholder="Pan Number *"
                  className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                  required
                />
              </div>
            )}

            <div className="mb-3 flex items-center">
              <input
                type="checkbox"
                name="receivePrasadam"
                checked={formData.receivePrasadam}
                onChange={handleMahaPrasadamCheckboxChange}
                className="mr-2 accent-[#C61D21]"
              />
              <label className="text-sm lg:text-base">
                I would like to receive Maha prasadam (Only within India)
              </label>
            </div>

            {showMahaPrasadamDetails && (
              <div className="my-3 flex flex-col space-y-2">
                {[
                  { name: "doorNumber", placeholder: "Door Number" },
                  {
                    name: "houseName",
                    placeholder: "House / Apartment / Building Name",
                  },
                  { name: "streetName", placeholder: "Street Name" },
                  { name: "area", placeholder: "Location / Area" },
                  { name: "city", placeholder: "City" },
                  { name: "state", placeholder: "State" },
                  { name: "country", placeholder: "Country" },
                  { name: "pincode", placeholder: "Pincode" },
                ].map((field) => (
                  <input
                    key={field.name}
                    type="text"
                    name={field.name}
                    placeholder={field.placeholder}
                    className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                ))}
              </div>
            )}

            <p className="text-xs lg:text-sm text-gray-400 mt-3">
              By continuing, you are agreeing to our{" "}
              <a href="#" className="text-yellow-500 underline">
                Terms of Use
              </a>{" "}
              and{" "}
              <a href="#" className="text-yellow-500 underline">
                Privacy Policy
              </a>
              .
            </p>
          </form>

          <button
            onClick={handleSubmit}
            className="w-full sm:w-[90%] lg:w-[40%] lg:text-xl bg-yellow-500 text-black font-bold py-3 mt-4 rounded-lg hover:bg-yellow-600 transition"
          >
            Donate{" "}
            {formData.totalAmount
              ? `₹${formData.totalAmount.toLocaleString()}`
              : ""}
          </button>
        </div>

        {/* Section 7 – Bank Details */}
        <div className="w-[90%] md:w-[65%] max-w-2xl border-2 border-solid border-[#C61D21] rounded-lg overflow-hidden">
          <h2 className="py-3 md:py-4 bg-[#C61D21] text-white text-center text-base md:text-3xl font-semibold">
            Donation Through Bank (NEFT/RTGS)
          </h2>
          <ul className="flex flex-col justify-center space-y-3 my-4 px-4 md:px-10">
            {[
              { label: "Bank Name", value: "HDFC Bank", id: "bankName" },
              { label: "Account Name", value: "ISKCON", id: "accountName" },
              {
                label: "Account Number",
                value: "50100436709020",
                id: "accountNumber",
              },
              { label: "IFSC Code", value: "HDFC000568", id: "ifscCode" },
              { label: "Branch", value: "ONE TOWN VIJAYAWADA", id: "branch" },
            ].map((item) => (
              <li
                key={item.id}
                className="flex items-center justify-between text-sm md:text-xl font-bold text-black"
              >
                <span className="text-[#C61D21]">
                  {item.label}:{" "}
                  <span className="text-black font-semibold">{item.value}</span>
                </span>
                <button
                  className="bg-gray-200 text-[10px] md:text-xs px-2 py-0.5 border border-[#C61D21] ml-3 rounded-full flex-shrink-0"
                  onClick={() => copyToClipboard(item.value, item.id)}
                >
                  {copiedText === item.id ? "Copied!" : "Copy"}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Section 8 – UPI */}
        <div className="mb-3  md:w-[65%] max-w-5xl border-2 md:border-4 border-[#C61D21] rounded-lg md:rounded-2xl overflow-hidden">
          <h2 className="py-2 md:py-4 bg-[#C61D21] text-white text-center text-base md:text-3xl font-semibold">
            Donate Through UPI
          </h2>
          <div className="flex flex-col md:flex-row justify-around items-center py-4 gap-4 px-3">
            <div className="text-center">
              <h2 className="text-base md:text-2xl text-[#C61D21] font-semibold">
                UPI ID:
              </h2>
              <p className="text-sm md:text-xl text-black">
                ISCKONVIJAYAWADA@IDFCBANK
              </p>
            </div>
            <img
              loading="lazy"
              src={barcode1}
              alt="UPI QR Code 1"
              width="180"
              height="180"
              className="rounded-lg"
            />
            <p className="text-lg lg:text-3xl font-semibold text-[#C61D21]">
              OR
            </p>
            <img
              loading="lazy"
              src={barcode2}
              alt="UPI QR Code 2"
              width="180"
              height="180"
              className="rounded-lg"
            />
          </div>
        </div>

        {/* Section 9 – After Donation */}
        <div className="w-full max-w-3xl text-left px-4 md:px-10 pb-10 mb-5">
          <h2 className="text-2xl md:text-3xl text-[#C61D21] font-bold mb-4">
            After Donation:
          </h2>
          <p className="text-sm md:text-xl text-black text-justify font-semibold leading-relaxed">
            Once you have donated, please share the transaction details or
            receipt via WhatsApp at{" "}
            <span className="text-[#C61D21]">+91 9955685568</span>. This helps
            us acknowledge your contribution and issue a receipt for tax
            exemption under Section 80G of the Income Tax Act.
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AnniversaryIskcon;
